import React from "react";
import './App.css';

import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { About } from './About';
import { Help } from './Help';
import { Terms } from './Terms';
import { Privacy } from './Privacy';
import { Song } from './Song';
import { Home } from './Home';
import Cookies from 'universal-cookie';
import uuid from 'react-uuid';

function App() {
  const cookies = new Cookies();

  function setUser(uid) {
    cookies.set('name', uid, { path: '/', maxAge: 864000 });
  }

  const existingId = cookies.get('name');
  if (!existingId) {
    setUser(uuid());
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AppLayout />}>
          <Route path="/" element={<Home user={cookies.get('name')} />} />
          <Route path="/about" element={<About />} />
          <Route path="/help" element={<Help />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/song" element={<Song />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
